import { useFieldArray, useFormContext } from 'react-hook-form'

import { PageSection, PageSectionFace } from 'ui/components'
import { Button } from 'ui/components/Buttons'
import { SarEdit } from '~bank-bsa-reporting/types'

import { emptySAR } from '../../../../../../../constants'
import { InstitutionActivitiesItem } from './InstitutionActivitiesItem'

export const FinancialInstitutionWhereActivityOccurredForm = () => {
  const { control } = useFormContext<SarEdit>()

  const { fields, append, remove } = useFieldArray({
    control,
    name: `institutionActivitiesInfo`
  })

  return (
    <PageSection
      face={PageSectionFace.THIRD}
      title="Step 2. Financial Institution Where Activity Occurred"
      anchor="step2"
    >
      {fields.map((field, index) => (
        <InstitutionActivitiesItem key={field.id} index={index} rowsNumber={fields.length} onDelete={remove} />
      ))}

      <Button
        face="primary"
        onClick={() => {
          append(emptySAR.institutionActivitiesInfo[0])
        }}
      >
        add
      </Button>
    </PageSection>
  )
}
